import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return null; // or a loading spinner
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export const PublicOnlyRoute = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return null; // or a loading spinner
    }

    if (isAuthenticated) {
        const from = location.state?.from;
        const isAuthPage = from?.pathname === '/login' || from?.pathname === '/register';
        const redirectPath = !from || isAuthPage
            ? '/chats'
            : `${from.pathname || ''}${from.search || ''}${from.hash || ''}`;
        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
};
